<!--
 * @Author: cmchiu
 * @Date: 2023-04-07 11:59:11
 * @LastEditTime: 2023-05-05 12:18:16
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\Page.vue
 * 
-->
<template>
    <div class="item-page">
        <breadcrumb />

        <div class="layer-container">
            <div v-html="ItemData.ItemContent"></div>
        </div>
    </div>
</template>

<script>
import { getItemContent } from '@/api/common'
import { breadcrumb } from '@c'

export default {
    name: 'itemPage',

    components: { breadcrumb },

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: this.$route.query.id,
            ItemData: {},
        }
    },

    created() {
        this.getMenuItemLs()
    },

    methods: {
        async getMenuItemLs(chgFilters) {
            const vm = this
            vm.configs.loading = true
            if (chgFilters) vm.menuItem.pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                MenuID: vm.MenuID,
                // ItemStatus: vm.menuItem.filter.status,
                // Keyword: vm.menuItem.filter.keyword,
                // PageSize: vm.menuItem.pages.pageSize,
                // PageCurrent: vm.menuItem.pages.pageCurrent,
            }
            await getItemContent(params)
                .then(res => {
                    // handle success
                    vm.ItemData = res.Items && res.Items.length > 0 ? res.Items[0] : {}
                    // let pages = vm.menuItem.pages
                    // pages.totalResult = res.TotalResult
                    // if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                    //     pages.pageCurrent = 1
                    // }
                })
                .catch(err => {
                    // handle error
                    vm.ItemData = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },
    },
}
</script>

<style scoped lang="scss"></style>
